import {Directive, ElementRef, Input, Renderer2, SimpleChanges} from '@angular/core';
import {Platform} from "ionic-angular";

@Directive({
    selector: '[hotkeys]',
    host: {'(window:keydown)': 'onKeyDown($event)'},
    providers: []
})
export class HotkeyDirective {

    @Input('hotkeys') hotkeys: string[] = []; // só recebe o default [] caso a propriedade seja [hotkeys]="", se for apenas hotkeys ou hotkeys="" não recebe
    @Input('append') append: boolean = false;

    private _element: HTMLElement;

    constructor(public element: ElementRef, public renderer: Renderer2, public platform:Platform) {

        this._element = element.nativeElement;

    }

    ngOnChanges(changes: SimpleChanges) {

        //console.log(changes); // para slider

    }

    ngOnInit() {

        // somente se for no PC
        if (this.hotkeys && this.append && !this.platform.is('mobile')) {

            let spanHotkey = this.renderer.createElement('span');

            this.renderer.addClass(spanHotkey,'position-absolute');
            this.renderer.setStyle(spanHotkey, 'font-size', '0.7em');
            this.renderer.setStyle(spanHotkey, 'right', '5px');
            this.renderer.setStyle(spanHotkey, 'bottom', '5px');
            this.renderer.setProperty(spanHotkey, 'innerHTML', this.hotkeys.join(' - '));

            this.renderer.addClass(this._element, 'position-relative');
            this.renderer.appendChild(this._element, spanHotkey);

        }

    }

    onKeyDown(e: KeyboardEvent) {

      //if (!this.hotkeys || this.platform.is('mobile')) {
        if (!this.hotkeys) {
            return;
        }

        for (let a in this.hotkeys) { // {'ctrl+F1': callback(), 'ctrl+F2': callback2()}

            let keys = this.hotkeys[a].toLowerCase().split('+'); // Ctrl+Shift+F7
            //let keys = this.hotkeys[a].toLowerCase().split('+'); // Ctrl+Shift+F7
            //keys.reverse();

            let pressed = (!e.key ? '' : e.key.toLowerCase());
            if (pressed == 'escape') {
                pressed = 'esc'; // ajuste
            }

            if ( ((e.ctrlKey  && keys.indexOf('ctrl')  > -1) || (!e.ctrlKey  && keys.indexOf('ctrl')  < 0)) &&
                 ((e.altKey   && keys.indexOf('alt')   > -1) || (!e.altKey   && keys.indexOf('alt')   < 0)) &&
                 ((e.shiftKey && keys.indexOf('shift') > -1) || (!e.shiftKey && keys.indexOf('shift') < 0)) &&
                 (keys.indexOf(pressed) > -1) ) {

                e.preventDefault();
                this._element.click();

            }

            /*
            let seqOk = true;
            for (let b in keys) {

                // verifica se as keys estão pressionadas mas não se existe key extra pressionada
                if (!(
                        (keys[b] == 'ctrl'  && e.ctrlKey)  ||
                        (keys[b] == 'alt'   && e.altKey)   ||
                        (keys[b] == 'shift' && e.shiftKey) ||
                        (keys[b] == e.key.toLowerCase())
                    )) {

                    seqOk = false;

                }
            }

            // aqui resolve se tem key extra pressionada
            if ( (e.ctrlKey  && keys.indexOf('ctrl')  == -1) ||
                 (e.altKey   && keys.indexOf('alt')   == -1) ||
                 (e.shiftKey && keys.indexOf('shift') == -1)) {

                seqOk = false;

            }

            if (seqOk) {

                e.preventDefault();
                this._element.click();

            }
            */

        }

    }

}



// WEBPACK FOOTER //
// ./src/directives/hotkey.ts